var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.359 17.75c3.156-1.733 5.548-3.053 5.755-3.156.66-.35 1.34-1.28 0-2a716.7 716.7 0 01-5.755-3.157l-4.146 4.187 4.146 4.126z",
    fill: "#FFD900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.213 13.624L1.012 26.93c.31.04.66-.042 1.072-.268.866-.474 10.045-5.487 16.275-8.911l-4.146-4.127z",
    fill: "#F43249"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.212 13.624l4.146-4.166S3.011 1.082 2.083.588C1.733.381 1.34.32.99.381l13.222 13.243z",
    fill: "#00EE76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.212 13.624L.99.381C.453.505 0 .979 0 1.949v23.413c0 .887.35 1.526 1.01 1.588l13.202-13.326z",
    fill: "#00D3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/google_play_icon.b178c9e422fec8d459b371bf5ee01fad.svg";
export { ForwardRef as ReactComponent };